import { forwardRef, Inject, Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot } from '@angular/router';
import { Store } from '@ngrx/store';
import { DependencyTreeCanActivate } from 'app/core/guards/dependency-tree.guard';
import { OrderFilterValuesLoadGuard } from 'app/core/guards/order-filter-values-load.guard';
import { logger } from 'app/core/util/logger';
import { Observable } from 'rxjs';
import * as fromRoot from '..';
import { OrdersClearFilterAction } from './orders.actions';
import { goAction } from '../router/router.actions';

/**
 * Guard to synchronously clear orders filter & result
 */
@Injectable({ providedIn: 'root' })
export class OrdersExecuteCleanFilterGuard implements CanActivate, DependencyTreeCanActivate {
  private store: Store<fromRoot.RootState>;

  constructor(@Inject(forwardRef(() => Store)) store) {
    this.store = store;
  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
    logger.debug('In OrdersExecuteCleanFilterGuard');
    this.store.dispatch(new OrdersClearFilterAction());
    this.store.dispatch(goAction({ path: 'orders/refresh' }));
    return false;
  }

  getDependencies(): any {
    return [OrderFilterValuesLoadGuard];
  }

  getDependencyRouteData(): any {}
}
